module.exports = __webpack_public_path__ + "img/button-success@2x.2df70dc5.png";